// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingEffect_typingContainer__6rDTO","typingText":"TypingEffect_typingText__t+ovz","cursor":"TypingEffect_cursor__TJUMk","blink":"TypingEffect_blink__bmNIo"};